import styled from 'styled-components';

export const CollectionList = styled.div`
  display: flex;
  flex-direction: column;
  grid-row-gap: 18px;
  margin-bottom: 30px;
`;
